import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import ModalStore from "components/Modal/ModalStore";

function clearSuccessQueryParam() {
  const url = new URL(window.location.href);
  if (!url.searchParams.has("success")) return;
  url.searchParams.delete("success");
  window.history.replaceState({}, "", url.toString());
}

/** Shows order confirmation when Stripe redirects back with ?success=true. */
export function useCheckoutReturnModal() {
  const location = useLocation();
  const shownRef = useRef(false);

  useEffect(() => {
    const orderSuccess = new URLSearchParams(location.search).get("success");
    if (orderSuccess !== "true" || shownRef.current) return;

    shownRef.current = true;
    ModalStore.openSimpleSuccess({
      icon: undefined,
      title: "SaddleFit Order Confirmed!",
      subtitle:
        "Your best-fitting saddle is on its way! Check your email for order details and tracking info.",
      onCancel: () => {
        ModalStore.closeAll();
        clearSuccessQueryParam();
      },
      shouldCloseOnOverlayClick: false,
    });
  }, [location.search]);
}
